<div class="doc-section">
    <div class="doc-card" #docCard>
        <style>
            .ack-page {
                font-family: 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
                font-size: 10.5pt;
                font-weight: 400;
                line-height: 1.65;
                color: #000000;
            }

            .ack-header {
                background-color: #1a2c5b;
                padding: 0 32px;
                height: 52px;
                display: flex;
                align-items: center;
            }

            .ack-brand {
                font-size: 18pt;
                font-weight: 700;
                color: #ffffff;
                line-height: 1;
            }

            .ack-brand-accent {
                color: #f0b429;
            }

            .ack-gold-bar {
                height: 5px;
                background-color: #f0b429;
            }

            .ack-body {
                padding: 20px 80px;
            }

            .ack-title {
                text-align: center;
                font-weight: 700;
                font-size: 13pt;
                text-transform: uppercase;
                color: #000000;
                margin-bottom: 4px;
            }

            .ack-subtitle {
                text-align: center;
                font-size: 10pt;
                color: #000000;
                margin-bottom: 20px;
            }

            .ack-info-table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 22px;
                border: 1px solid #d1d9ea;
            }

            .ack-info-table td {
                padding: 10px 14px;
                border: 1px solid #d1d9ea;
                font-size: 10.5pt;
                width: 50%;
            }

            .ack-info-table td.lbl {
                background-color: #eef1f8;
                font-weight: 700;
                color: #000000;
            }

            .ack-info-table td.lbl-dark {
                background-color: #1a2c5b;
                color: #ffffff;
                font-weight: 700;
                font-size: 10pt;
            }

            .ack-info-table td.val {
                background-color: #ffffff;
                color: #000000;
                font-weight: 700;
                text-transform: capitalize;
            }

            .ack-info-table td.val-dark {
                background-color: #dce3f5;
                font-weight: 700;
                color: #000000;
                font-size: 10.5pt;
            }

            .ack-p {
                margin-bottom: 10px;
                font-size: 10.5pt;
                color: #000000;
            }

            .ack-sub {
                margin-top: 6px;
                margin-bottom: 6px;
                color: #000000;
                font-size: 10.5pt;
            }

            .ack-bold {
                font-weight: 700;
                color: #000000;
            }

            .ack-ol {
                margin-left: 20px;
                margin-top: 8px;
                margin-bottom: 14px;
            }

            .ack-ol li {
                margin-bottom: 8px;
                font-size: 10.5pt;
                color: #000000;
                padding-left: 4px;
            }

            .ack-witness {
                text-align: center;
                margin-top: 20px;
                margin-bottom: 20px;
                padding: 12px;
                background-color: #f7f9fc;
                border: 1px solid #e2e8f0;
                font-size: 10.5pt;
                font-weight: 600;
                color: #000000;
                border-radius: 12px;
            }

            .ack-sig-block {
                margin-top: 22px;
                margin-bottom: 18px;
                padding: 20px;
                background-color: #fafbfd;
                border: 1px solid #e2e8f0;
                border-top: 3px solid #1a2c5b;
            }

            .ack-sig-block-heading {
                font-weight: 700;
                font-size: 10pt;
                text-transform: uppercase;
                letter-spacing: 1px;
                color: #000000;
                margin-bottom: 16px;
            }

            .ack-sig-table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 14px;
            }

            .ack-sig-table td {
                vertical-align: bottom;
                padding: 0;
            }

            .ack-sig-label {
                display: block;
                font-size: 8.5pt;
                font-weight: 700;
                color: #000000;
                text-transform: uppercase;
                letter-spacing: 0.5px;
                margin-bottom: 5px;
            }

            .ack-sig-line {
                border-bottom: 1px solid #374151;
                height: 26px;
                display: block;
                width: 100%;
            }

            .ack-footer {
                background-color: #1a2c5b;
                padding: 0 32px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 8pt;
                color: #9ab0d8;
            }

            .ack-sig-canvas {
                display: block;
                width: 100%;
                height: 90px;
                border: 1.5px dashed #a0aec0;
                border-radius: 4px;
                background: #f8faff;
                cursor: crosshair;
                touch-action: none;
                transition: border-color 0.2s, background 0.2s;
            }

            .ack-sig-canvas:hover {
                border-color: #1a2c5b;
                background: #eef2ff;
            }

            .ack-sig-canvas.has-sig {
                border: 1.5px solid #1a2c5b;
                background: #f0f4ff;
                border-radius: 4px;
            }
        </style>

        <div class="ack-page">
            <div class="ack-header">
                <span class="ack-brand">E.A.S.Y. <span class="ack-brand-accent">Liens</span></span>
            </div>
            <div class="ack-gold-bar"></div>

            <div class="ack-body">
                <div class="ack-title">Acknowledgment of Assignment</div>
                <div class="ack-subtitle">({{ patientName }} / {{ providerName }})</div>

                <table class="ack-info-table">
                    <tr>
                        <td class="lbl">Patient</td>
                        <td class="val">{{ patientLast }}, {{ patientFirst }}</td>
                    </tr>
                    <tr>
                        <td class="lbl">Provider</td>
                        <td class="val">{{ providerName }}</td>
                    </tr>
                    <tr>
                        <td class="lbl">Date(s) of Service</td>
                        <td class="val">{{ dateOfService }}</td>
                    </tr>
                    <tr>
                        <td class="lbl">Account Number</td>
                        <td class="val">{{ accountNumber }}</td>
                    </tr>
                    <tr>
                        <td class="lbl">Full Billed Charges</td>
                        <td class="val">{{ billedCharges }}</td>
                    </tr>
                    <tr>
                        <td class="lbl lbl-dark">Amount Held in Trust for This Account</td>
                        <td class="val val-dark">{{ trustAmount }}</td>
                    </tr>
                </table>

                <p class="ack-p">
                    This <span class="ack-bold">ACKNOWLEDGMENT OF ASSIGNMENT</span>
                    (&ldquo;Acknowledgment&rdquo;) is made by
                    Injury Counsel for the benefit of and in express reliance by E.A.S.Y. Liens, LLC
                    (&ldquo;<span class="ack-bold">Factor</span>&rdquo;). Injury Counsel agrees that Factor is
                    entitled to
                    rely on the representations herein.
                </p>

                <div class="ack-sub">Injury Counsel hereby:</div>
                <ol class="ack-ol">
                    <li><span class="ack-bold">ACKNOWLEDGES</span> Factor&rsquo;s valid legal interest in the
                        settlement proceeds pursuant to Patient&rsquo;s Assignment;</li>
                    <li><span class="ack-bold">ACKNOWLEDGES</span> that Factor will not issue payment to Patient
                        unless this Acknowledgment is executed and delivered; and</li>
                    <li><span class="ack-bold">ACKNOWLEDGES</span> that the Trust Amount is currently held in
                        the Patient&rsquo;s IOTA trust account and is unencumbered except for Provider&rsquo;s
                        lien and Factor&rsquo;s Assignment.</li>
                </ol>

                <div class="ack-witness">
                    <span class="ack-bold">IN WITNESS WHEREOF,</span> Injury Counsel executes below, intending reliance by Factor.
                </div>

                <div class="ack-sig-block">
                    <div class="ack-sig-block-heading">By Injury Counsel:</div>
                    <table class="ack-sig-table">
                        <tr>
                            <td>
                                <span class="ack-sig-label">Full Name &nbsp;<span
                                        style="font-weight:400;text-transform:none;">(please
                                        print)</span></span>
                                <span class="ack-sig-line">{{ attorneyName }}</span>
                            </td>
                        </tr>
                    </table>
                    <table class="ack-sig-table">
                        <tr>
                            <td>
                                <span class="ack-sig-label">Signature <span
                                        style="font-weight:400;text-transform:none;font-size:8pt;">(draw
                                        below)</span></span>
                                <canvas #sigCanvas class="ack-sig-canvas"
                                    [class.has-sig]="!state.isDrawEmpty"
                                    (mousedown)="mouseDown.emit($event)"
                                    (mousemove)="mouseMove.emit($event)"
                                    (mouseup)="mouseUp.emit()"
                                    (mouseleave)="mouseUp.emit()"
                                    (touchstart)="touchStart.emit($event)"
                                    (touchmove)="touchMove.emit($event)"
                                    (touchend)="touchEnd.emit()">
                                </canvas>
                            </td>
                        </tr>
                    </table>
                    <table class="ack-sig-table">
                        <tr>
                            <td>
                                <span class="ack-sig-label">Effective Date</span>
                                <div class="inline-date-picker">
                                    <app-date-picker placeholder="Select date" [showLabel]="false"
                                        [(ngModel)]="state.selectedDate"></app-date-picker>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div><!-- /.ack-body -->

            <div class="ack-footer">
                <span>E.A.S.Y. Liens, LLC &mdash; Confidential</span>
                <span>Acknowledgment of Assignment &mdash; Page 1 of 1</span>
            </div>
        </div><!-- /.ack-page -->
    </div><!-- /.doc-card -->

</div>
